import React from "react";
import { Form, Table, Select } from "antd";
import { connect } from "react-redux";
import { getListStructure } from "../../../../services/api/Api";
import { injectIntl } from "react-intl";
import { cloudGQLList } from "services/graphql/GraphQl";
import {
   showName,
   validateTranslations,
   syncBoardTranslationsToService,
   updateTranslationsUsage,
} from "@util/Scripts";
import { ListScripts } from "../../ListWidget/Lists/listScripts";
import IntlMessages from "@util/IntlMessages";

import "../AdvertisementList/advertisementListSettings.less";
import { Message, Switch, Button, Spin, Input, Popconfirm } from "../../../BP2Components";
import { setWidgetInSheetParams } from "../../../../appRedux/actions/Boards";
import { updateWidgetSettings } from "../../../../appRedux/actions/WidgetSettings";

const EditableContext = React.createContext();
const EditableRow = ({ form, index, ...props }) => (
   <EditableContext.Provider value={form}>
      <tr {...props} />
   </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

const { Option } = Select;

class EditableCell extends React.Component {
   state = {
      editing: false,
   };

   toggleEdit = () => {
      const editing = !this.state.editing;
      this.setState({ editing }, () => {
         if (editing) {
            this.input?.focus();
         }
      });
   };

   save = (e) => {
      const { record, handleSave } = this.props;
      this.form.validateFields((error, values) => {
         if (error && error[e.currentTarget.id]) {
            return;
         }
         this.toggleEdit();
         if (values.itemsPerPage) {
            values.itemsPerPage = +values.itemsPerPage;
         }
         handleSave({ ...record, ...values });
      });
   };

   renderCell = (form) => {
      this.form = form;
      const { children, dataIndex, record, title } = this.props;
      const { editing } = this.state;
      return editing ? (
         <label style={{ margin: 0 }}>
            {form.getFieldDecorator(dataIndex, {
               rules: [
                  {
                     message: (
                        <>
                           {title} <IntlMessages id="title.isRequired" />
                        </>
                     ),
                  },
               ],
               initialValue: record[dataIndex],
            })(
               <Input
                  style={{ width: "220px", fontSize: "12px" }}
                  ref={(node) => (this.input = node)}
                  onPressEnter={this.save}
                  onBlur={this.save}
               />,
            )}
         </label>
      ) : (
         <div
            className="editable-cell-value-wrap"
            style={{ paddingRight: 24 }}
            onClick={this.toggleEdit}
         >
            {children}
         </div>
      );
   };

   render() {
      const { editable, dataIndex, title, record, index, handleSave, children, ...restProps } =
         this.props;
      return (
         <td {...restProps}>
            {editable ? (
               <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
            ) : (
               children
            )}
         </td>
      );
   }
}

class ProductListSettings extends React.Component {
   constructor(props) {
      super(props);
      this.columns = [
         {
            title: <IntlMessages id="settings.serieName" />,
            dataIndex: "name",
            editable: true,
         },
         {
            title: <IntlMessages id="settings.query" />,
            dataIndex: "query",
            editable: true,
            width: 180,
            maxWidth: 400,
         },
         {
            title: <IntlMessages id="settings.listId" />,
            dataIndex: "listId",
            editable: true,
            width: 60,
         },
         {
            title: <IntlMessages id="settings.itemsPerPage" />,
            dataIndex: "itemsPerPage",
            editable: true,
         },
         {
            title: <IntlMessages id="boardManager.operation" />,
            dataIndex: "operation",
            render: (text, record) =>
               this.state.listWidgetSeries.length >= 1 ? (
                  <>
                     <Popconfirm
                        title="Sure to delete?"
                        onConfirm={() => this.handleDelete(record.listWidgetSerieKey)}
                     >
                        <a className="gx-mr-5">
                           <IntlMessages id="global.delete" />
                        </a>
                     </Popconfirm>
                  </>
               ) : null,
         },
      ];

      let rows = [];
      let series = [];

      if (props.listWidgetSeries !== undefined && props.listWidgetSeries.length > 0) {
         series = props.listWidgetSeries;
         rows = [];
      }
      series.forEach((serie) => {
         rows.push({
            listWidgetSerieKey: props.listWidgetSeries.indexOf(serie),
            id: serie.id,
            name: serie.name,
            query: serie.query,
            listId: serie.listId,
            hasPhoto: serie.hasPhoto,
            showMainTitleLabel: serie.showMainTitleLabel,
            showSubtitleLabel: serie.showSubtitleLabel,
            showKeyInfo: serie.showKeyInfo,
            showSubKeyInfo: serie.showSubKeyInfo,
            showDescription: serie.showDescription,
            itemsPerPage: serie.itemsPerPage,
            columnProperties: serie.columnProperties,
            listWidgetSerieSettings: serie.listWidgetSerieSettings,
         });
      });
      this.state = {
         id: this.props.id,
         name: this.props.name,
         xsWidth: this.props.xs,
         smWidth: this.props.sm,
         mdWidth: this.props.md,
         lgWidth: this.props.lg,
         xlWidth: this.props.xl,
         priority: this.props.priority,
         showListName: this.props.showListName,
         listWidgetSeries: this.props.listWidgetSeries,
         count: rows.length,
         columnProperties: this.props.columnProperties,
         selected: this.props.selectedSerie,
         hasPhoto: this.props.hasPhoto,
         showMainTitleLabel: this.props.showMainTitleLabel,
         showSubtitleLabel: this.props.showSubtitleLabel,
         showKeyInfo: this.props.showKeyInfo,
         showSubKeyInfo: this.props.showSubKeyInfo,
         showDescription: this.props.showDescription,
         currentRowClicked: null,
         stateChange: 0,
         buttonsInSelectMode: this.props.buttonsInSelectMode,
         pricingTableView: this.props?.pricingTableView,
         expandedRow: null,
         ...this.props.value,
         ...(this.props.value?.listTitle &&
         this.props.serviceTranslations?.[this.props.value.listTitle]
            ? {
                 [`name${this.props.locale}`]:
                    this.props.serviceTranslations[this.props.value.listTitle],
              }
            : {}),
      };

      this.filtrColumns = () => {
         return this.props.columns.filter(({ title }) => {
            let isValid = true;
            this.props.rows.forEach((row) => {
               if (
                  row[title] instanceof Array ||
                  (typeof row[title] === "object" && row[title] && !row[title].value)
               )
                  isValid = false;
            });
            return isValid;
         });
      };
   }

   getSerieById = (serieId) => {
      const { listWidgetSeries } = this.state;
      let searchedSerie = null;
      listWidgetSeries.forEach((serie) => {
         if (serieId == serie.listWidgetSerieKey) {
            searchedSerie = serie;
         }
      });
      return searchedSerie;
   };

   handleSubmit = (e) => {
      e.preventDefault();

      const validTranslations = validateTranslations(this.state);

      if (!validTranslations) {
         Message.error(this.props.intl.formatMessage({ id: "widget.invalidTranslations" }));
         return;
      }

      const { expandedRow } = this.state;
      this.setState((prevState) => ({
         stateChange: prevState.stateChange + Math.random(),
      }));
      var i = 0;

      if (expandedRow && expandedRow.columnProperties !== undefined && expandedRow !== null) {
         expandedRow.columnProperties.map((col) => {
            col.orderKey = i;
            i++;
            if (col.addition !== true) {
               col.addition = false;
            }
            return null;
         });
      }
      this.props.setWidgetInSheetParams(this.state);
      if (this.state.listTitle && this.props.allLanguages?.length) {
         const translationsToSync = [
            {
               key: this.state.listTitle,
               category: "productList.name",
               values: this.props.allLanguages.reduce((acc, { language }) => {
                  acc[language] = this.state[`name${language}`] ?? "";
                  return acc;
               }, {}),
            },
         ];
         syncBoardTranslationsToService(translationsToSync, this.props.allLanguages).then(
            (results) => {
               if (!results?.some((r) => r.status === "rejected")) {
                  updateTranslationsUsage(this.props.intl, true);
               }
            },
         );
      }
   };
   SwitchShowTitle = ({ showTitle, className, disabled }) => (
      <Switch
         onChange={(e) => this.handleSwitch(e, showTitle)}
         defaultChecked={this.props.value[showTitle]}
         className={className}
         disabled={disabled}
      />
   );
   handleSwitch = (checked, name) => {
      this.setState({ ...this.state, [name]: checked });
      this.props.updateWidgetSettings(this.state);
   };

   handleChange = (e) => {
      this.setState({ ...this.state, [e.target.name]: e.target.value });
   };

   handleAdd = () => {
      const { count, listWidgetSeries } = this.state;
      const newData = {
         listWidgetSerieKey: count,
         id: Math.floor(Math.random() * 100000) + 1,
         query: "Click to add query",
         name: "Click to add name",
         listId: 12,
         itemsPerPage: 10,
         listWidgetSerieSettings: ListScripts.getBasicSerieSettings(),
         columnProperties: [],
      };
      this.setState((prevState) =>
         prevState.listWidgetSeries
            ? {
                 listWidgetSeries: [...listWidgetSeries, newData],
                 count: count + 1,
              }
            : { listWidgetSeries: [newData] },
      );
      this.props.updateWidgetSettings(this.state);
   };
   handleSave = (row) => {
      const newData = [...this.state.listWidgetSeries];
      const index = newData.findIndex((item) => row.listWidgetSerieKey === item.listWidgetSerieKey);
      const item = newData[index];
      Message.success(this.props.intl.formatMessage({ id: "global.saved" }));
      newData.splice(index, 1, {
         ...item,
         ...row,
      });
      this.setState({ listWidgetSeries: newData });
      this.props.updateWidgetSettings(this.state);
   };
   handleDelete = (listWidgetSerieKey) => {
      const series = [...this.state.listWidgetSeries];
      this.setState({
         listWidgetSeries: series.filter((item) => item.listWidgetSerieKey !== listWidgetSerieKey),
      });
      this.props.updateWidgetSettings(this.state);
   };

   onExpandRow = (rowClicked, currentRowClicked) => {
      this.setState({
         selected: currentRowClicked.listWidgetSerieKey,
         currentRowClicked: currentRowClicked,
      });

      if (isNaN(currentRowClicked.listId) == true) {
         this.getQueryData(currentRowClicked);
      } else {
         this.getBPdata(currentRowClicked);
      }
      this.setState({ expandedRow: currentRowClicked });
   };

   getQueryData = (clickedRow) => {
      cloudGQLList(clickedRow.query, 0, 100000).then((resp) => {
         let length = this.mapQuery(clickedRow.query, resp).length;
         if (length > 0) {
            cloudGQLList(clickedRow.query, 1, clickedRow.itemsPerPage).then((res) => {
               let mappedResponse = this.mapQuery(clickedRow.query, res);
               this.renderCloudResponse(mappedResponse, length);
            });
         }
      });
   };
   renderCloudResponse(res, length) {
      if (res[0]) {
         const cols = Object.keys(res[0]);

         const columnsCopy = [];
         cols.forEach((column) => {
            columnsCopy.push({
               title: column,
               dataIndex: column,
               label: column,
            });
         });

         this.setState({
            ...this.state.listWidgetSeries[this.props.selectedSerie],
            ...(this.state.listWidgetSeries[this.props.selectedSerie].columnProperties =
               columnsCopy),
         });
      }
   }

   mapQuery(query, resp) {
      query = query.replace(/ /g, "");
      query = query.replace(/}/g, "");
      let firstSplit = query.split("(");
      let funName = firstSplit[0].substr(1);
      let response;
      if (firstSplit[1]) {
         let secondSplit = firstSplit[1].split("{");
         let params = [];
         for (let i = 0; i < secondSplit.length - 1; i++) {
            if (!secondSplit[i].includes(":")) {
               params.push(secondSplit[i]);
            }
         }
         let data = resp.data.data[funName];
         if (params.length === 0) {
            response = data;
         } else if (data === null) {
            response = [];
         } else {
            if (params.length === 1) response = data[params[0]];
            if (params.length === 2) response = data[params[0]][params[1]];
            if (params.length === 3) response = data[params[0]][params[1]][params[2]];
         }
      } else {
         response = [];
      }
      return response;
   }

   getBPdata = (clickedRow) => {
      if (clickedRow.columnProperties && clickedRow.columnProperties.length === 0) {
         getListStructure(clickedRow.listId).then((res) => {
            const responseData = res.data.getStructure;
            this.setState({
               ...clickedRow,
               ...(clickedRow.columnProperties = responseData.columns),
            });
         });
      }
   };

   summary = () => {
      const clickedRow = this.getSerieById(this.state.selected);
      const dataSource = clickedRow.columnProperties;

      const col = [
         {
            title: <IntlMessages id="settings.label" />,
            dataIndex: "label",
            key: "label",
            width: "50%",
         },
         {
            title: <IntlMessages id="settings.summaryColumn" />,
            dataIndex: "operation",
            width: "50%",
            render: (text, record) => {
               return dataSource.length >= 1 ? (
                  <Switch onChange={(e) => handleSwitch(e, record)} checked={record.addition} />
               ) : null;
            },
         },
      ];
      const data = clickedRow.listWidgetSerieSettings;
      const colSettings = [
         {
            title: <IntlMessages id="global.settings" />,
            dataIndex: "label",
            key: "label",
            width: "50%",
         },
         {
            title: <IntlMessages id="settings.setSettings" />,
            dataIndex: "setSettings",
            width: "50%",
            render: (text, record) =>
               data.length >= 1 ? (
                  <>
                     <Switch
                        onChange={(e) => handleSwitch(e, record)}
                        defaultChecked={record.addition}
                     />
                  </>
               ) : null,
         },
      ];
      const handleSwitch = (checked, record) => {
         this.setState(
            clickedRow.listWidgetSerieSettings.forEach((setting) =>
               setting.label === record.label ? (setting.addition = checked) : null,
            ),
         );
         dataSource.map((item) => {
            if (item.label === record.label) {
               item.addition = checked;
               item.serie = this.props.selectedSerie;
            }
            return null;
         });

         this.props.updateWidgetSettings(this.state);
      };

      return (
         <>
            {dataSource && dataSource.length ? (
               <>
                  <Table
                     className="gx-mb-3"
                     size="small"
                     dataSource={data}
                     columns={colSettings}
                     pagination={false}
                  />
                  <Table size="small" dataSource={dataSource} columns={col} />
               </>
            ) : (
               <>
                  <Spin
                     style={{
                        background: "white",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                     }}
                  />
               </>
            )}
         </>
      );
   };

   isDefaultValueValid = (value) => {
      if (this.filtrColumns().find(({ techName }) => techName === value)) {
         return true;
      } else {
         return false;
      }
   };

   SelectColumn = ({ item, disabled }) => (
      <Select
         value={this.isDefaultValueValid(this.state[item]) ? this.state[item] : "-"}
         defaultValue={this.state[item]}
         onChange={(e) => this.handleSelectChange(e, item)}
         disabled={disabled}
      >
         <Option value={"-"}>-</Option>
         {this.filtrColumns().map(({ title, techName }, i) => (
            <Option value={techName} key={i}>
               {title}
            </Option>
         ))}
      </Select>
   );

   handleSelectChange = (value, name) => {
      this.setState(() => ({
         [name]: value,
      }));
      this.props.updateWidgetSettings(this.state);
   };
   componentDidUpdate() {
      this.props.allLanguages.forEach((item) => {
         if (typeof this.state[`name${item.language}`] !== "string") {
            this.setState({
               ...this.state,
               [`name${item.language}`]: `${showName(
                  `${item.language}`,
                  this.props.value.listTitle,
                  this.props.data,
               )}`,
            });
         }
         if (typeof this.state[`name${item.language}`] === "object") {
            this.setState({
               ...this.state,
               [`name${item.language}`]: "",
            });
         }
      });
   }

   render() {
      const { listWidgetSeries } = this.state;
      const components = {
         body: {
            row: EditableFormRow,
            cell: EditableCell,
         },
      };
      const cols = this.columns.map((col) => {
         if (!col.editable) {
            return col;
         }
         return {
            ...col,
            onCell: (record) => ({
               record,
               editable: col.editable,
               dataIndex: col.dataIndex,
               title: col.title,
               handleSave: this.handleSave,
            }),
         };
      });
      return (
         <form onSubmit={this.handleSubmit}>
            <div className="widget-settings">
               <div className="widget-settings__inner">
                  <label key="title" className="widget-settings__inner__label">
                     <IntlMessages id="settings.listTitle" />:
                     <Input
                        type="listTitle"
                        name="listTitle"
                        defaultValue={this.props.value.listTitle}
                        onChange={this.handleChange}
                     />
                  </label>
                  {this.props.allLanguages.map((item) => (
                     <label
                        className="widget-settings__inner__label"
                        key={"translatedTitle" + item.language}
                     >
                        <IntlMessages id={`widgetTitle${item.language}`} />:
                        <Input
                           type="translation"
                           className="translationName"
                           name={`name${item.language}`}
                           defaultValue={
                              this.state[`name${item.language}`]
                                 ? this.state[`name${item.language}`]
                                 : showName(
                                      `${item.language}`,
                                      this.props.value.listTitle,
                                      this.props.data,
                                   )
                           }
                           onChange={this.handleChange}
                        />
                     </label>
                  ))}

                  <label key="pricingTableView" className="widget-settings__inner__label">
                     <IntlMessages id="settings.pricingTableView" />:
                     <Select
                        defaultValue={this.props.value.pricingTableView}
                        onChange={(e) => this.handleSwitch(e, "pricingTableView")}
                     >
                        <Option value={true}>
                           {this.props.intl.formatMessage({ id: "productList.pricingTableView" })}
                        </Option>
                        <Option value={false}>
                           {this.props.intl.formatMessage({ id: "productList.classicView" })}
                        </Option>
                     </Select>
                  </label>

                  <label key="hasPhoto" className="widget-settings__inner__label">
                     <IntlMessages id="settings.visiblePhoto" />:
                     <Switch
                        onChange={(e) => this.handleSwitch(e, "hasPhoto")}
                        defaultChecked={this.props.value.hasPhoto}
                     />
                  </label>

                  <label key="showButtonAddToCart" className="widget-settings__inner__label">
                     <IntlMessages id="settings.showAddToCartButton" />:
                     <Switch
                        onChange={(e) => this.handleSwitch(e, "showButtonAddToCart")}
                        defaultChecked={
                           this.props.value.showButtonAddToCart !== false ? true : false
                        }
                     />
                  </label>

                  <label key="buttonsInSelectMode" className="widget-settings__inner__label">
                     <IntlMessages id="settings.buttonsInSelectMode" />:
                     <Switch
                        onChange={(e) => this.handleSwitch(e, "buttonsInSelectMode")}
                        defaultChecked={this.props.value.buttonsInSelectMode}
                     />
                  </label>
                  <label key="photoColumn" className="widget-settings__inner__label">
                     <IntlMessages id="settings.photoColumn" />:
                     <Select
                        defaultValue={this.props.value.photoColumn}
                        // TODO: change this to proper function after component refactor
                        onChange={(value) => this.handleSwitch(value, "photoColumn")}
                     >
                        <Option value={"-"}>-</Option>
                        {this.props.columns.map(({ title }) => (
                           <Option value={title} key={title}>
                              {title}
                           </Option>
                        ))}
                     </Select>
                  </label>
                  <label key="item_id" className="widget-settings__inner__label">
                     <IntlMessages id="settings.item_id" />:
                     <div className="settingsColumnSelect">
                        <this.SelectColumn item={"itemIdColumn"} />
                     </div>
                  </label>
                  <label key="mainTitle" className="widget-settings__inner__label">
                     <IntlMessages id="settings.mainTitleAdvertismentList" />:
                     <div className="settingsColumnSelect">
                        <this.SelectColumn item={"mainTitle"} />
                        <IntlMessages id="settings.showColumnName" />
                        <Switch
                           onChange={(e) => this.handleSwitch(e, "showMainTitleLabel")}
                           defaultChecked={this.props.value.showMainTitleLabel}
                        />
                     </div>
                  </label>
                  <label key="showSubtitleLabel" className="widget-settings__inner__label">
                     <IntlMessages id="settings.subtitleAdvertismentList" />:
                     <div className="settingsColumnSelect">
                        <this.SelectColumn item={"subtitle"} />
                        <IntlMessages id="settings.showColumnName" />
                        <Switch
                           onChange={(e) => this.handleSwitch(e, "showSubtitleLabel")}
                           defaultChecked={this.props.value.showSubtitleLabel}
                        />
                     </div>
                  </label>
                  <label key="keyInfo" className="widget-settings__inner__label">
                     <IntlMessages id="settings.keyInfoAdvertismentList" />:
                     <div className="settingsColumnSelect">
                        <this.SelectColumn item={"keyInfo"} />
                        <IntlMessages id="settings.showColumnName" />
                        <Switch
                           onChange={(e) => this.handleSwitch(e, "showKeyInfoLabel")}
                           defaultChecked={this.props.value.showKeyInfoLabel}
                        />
                     </div>
                  </label>
                  <label key="subKeyInfo" className="widget-settings__inner__label">
                     <IntlMessages id="settings.subKeyInfoAdvertismentList" />:
                     <div className="settingsColumnSelect">
                        <this.SelectColumn item={"subKeyInfo"} />
                        <IntlMessages id="settings.showColumnName" />
                        <Switch
                           onChange={(e) => this.handleSwitch(e, "showSubKeyInfo")}
                           defaultChecked={this.props.value.showSubKeyInfo}
                        />
                     </div>
                  </label>
                  <label key="description" className="widget-settings__inner__label">
                     <IntlMessages id="settings.description" />:
                     <div className="settingsColumnSelect">
                        <this.SelectColumn item={"description"} />
                        <IntlMessages id="settings.showColumnName" />
                        <Switch
                           onChange={(e) => this.handleSwitch(e, "showDescription")}
                           defaultChecked={this.props.value.showDescription}
                        />
                     </div>
                  </label>
                  <label>
                     <Button
                        style={{ marginBottom: 20 }}
                        onClick={this.handleAdd}
                        buttonType="primary"
                     >
                        <IntlMessages id="settings.AddSerie" />
                     </Button>
                  </label>
                  <Table
                     components={components}
                     rowClassName={() => "list-settings-queries"}
                     bordered
                     className="gx-table-responsive"
                     dataSource={listWidgetSeries}
                     expandedRowRender={this.summary}
                     onExpand={this.onExpandRow}
                     columns={cols}
                     pagination={false}
                     size="small"
                  />
               </div>
               <Button buttonType="primary" htmlType="submit" style={{ marginTop: 15 }}>
                  <IntlMessages id="global.preview" />
               </Button>
            </div>
         </form>
      );
   }
}

const mapStateToProps = (state) => {
   return {
      widgets: state.widgetSettings.settings,
      allLanguages: state.settings.allLanguages,
      locale: state.settings.locale,
      serviceTranslations: state.translations.translations,
   };
};

export default connect(mapStateToProps, {
   setWidgetInSheetParams,
   updateWidgetSettings,
})(injectIntl(ProductListSettings));
